// extracted by mini-css-extract-plugin
export default {"DiffEntry":"PullRequestDiffsList-module__DiffEntry--jsSLA"};